/**
 * Firmware strings that are NOT an answer.
 *
 * BootNotification's chargePointVendor / chargePointModel are REQUIRED
 * by OCPP 1.6, so firmware always sends something — but "something" is
 * often a build placeholder rather than a manufacturer. Writing those
 * into `vendor` as if they were real makes a charger look answered when
 * it is not, and a regulatory filing is the wrong place to discover it.
 *
 * A match still PERSISTS the raw value (it is evidence, and the admin
 * contradiction panel can say "the charger reports WWWW, which is not a
 * manufacturer" rather than showing a blank) but marks the field
 * `placeholder` instead of `self_reported`. The registration export's
 * gap trigger keys on "not admin_override", so placeholder rows keep
 * appearing in the gap report exactly as unanswered ones do.
 *
 * DELIBERATELY A SMALL HARDCODED ARRAY, not a config surface. It is a
 * list of specific junk strings observed in the field; making it
 * operator-editable would invite someone to "fix" a gap by adding a real
 * manufacturer to it.
 */
/** Observed in the field. WWWW and SingleSocketCharger both come from
 *  the AC_DUL firmware on the Hamilton test unit. */
const PLACEHOLDER_STRINGS = [
    'WWWW',
    'SingleSocketCharger',
    'Unknown',
];
function normalise(v) {
    return String(v ?? '').trim().toLowerCase();
}
/**
 * True when a vendor or model string carries no information — a known
 * placeholder, or empty after trimming.
 */
export function isPlaceholderIdentity(value) {
    const s = normalise(value);
    if (s === '')
        return true;
    return PLACEHOLDER_STRINGS.some((p) => p.toLowerCase() === s);
}
/**
 * True when a reported serial carries no information beyond what we
 * already knew.
 *
 * The extra rule over `isPlaceholderIdentity`: a serial EQUAL TO THE
 * OCPP IDENTITY is a firmware shortcut, not a hardware serial. The
 * Hamilton unit reports chargePointSerialNumber === 'CU89TVWKPVJ8',
 * which is its own identity — echoing the identity back tells us
 * nothing about the physical device.
 */
export function isPlaceholderSerial(serial, identity) {
    const s = normalise(serial);
    if (s === '')
        return true;
    if (s === normalise(identity))
        return true;
    return PLACEHOLDER_STRINGS.some((p) => p.toLowerCase() === s);
}
//# sourceMappingURL=chargerPlaceholders.js.map